import { ExportButton as ReactAdminExportButton, ExportButtonProps } from 'react-admin'

export const ExportButton = (props: ExportButtonProps): JSX.Element => {
  return <ReactAdminExportButton {...props} size='medium' />
}
